import React from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

const SPRING = { type: "spring", stiffness: 380, damping: 26 };

const VARIANTS = {
  primary: "bg-brand-green text-white hover:bg-[#007038] shadow-premium",
  secondary: "bg-brand-surface text-brand-primary border border-brand-border hover:border-brand-green hover:text-brand-green shadow-premium",
  ghost: "bg-transparent text-brand-primary hover:bg-brand-surfaceElevated",
  red: "bg-brand-red text-white hover:bg-[#a01b20] shadow-premium",
  gold: "bg-brand-gold text-brand-primary hover:brightness-95 shadow-premium",
  outline: "bg-transparent text-brand-primary border-2 border-brand-primary hover:bg-brand-primary hover:text-brand-background",
};

const SIZES = {
  sm: "h-9 px-4 text-sm rounded-lg",
  md: "h-11 px-6 text-sm rounded-xl",
  lg: "h-14 px-8 text-base rounded-2xl",
};

/**
 * MotionButton — premium tactile button with hover scale & tap feedback.
 *  - Spring hover at 1.02 scale
 *  - whileTap 0.96 (mobile-friendly)
 *  - Variants align with Italian editorial palette
 */
export default function MotionButton({
  variant = "primary",
  size = "md",
  className,
  children,
  asChild = false,
  ...props
}) {
  const baseCls = cn(
    "btn-tactile inline-flex items-center justify-center gap-2 font-medium",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-green focus-visible:ring-offset-2 focus-visible:ring-offset-brand-background",
    "disabled:opacity-50 disabled:pointer-events-none",
    VARIANTS[variant],
    SIZES[size],
    className,
  );

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.96 }}
      transition={SPRING}
      className={baseCls}
      {...props}
    >
      {children}
    </motion.button>
  );
}
